export class ServiceNames {
  static Stats: string = 'stats';

  static Ga4: string = 'ga4';

  static Klaviyo: string = 'klaviyo';
}
